import React from 'react';
import Header from './Header';
import { useSelector } from "react-redux";
import { selectors as imgSelector } from "../../../state/features/header";

const HeaderContainer = (props :any) => {

    const { imgBaseUrlSelectors }: any = useSelector((state) => ({
        imgBaseUrlSelectors: imgSelector.imgbaseUrl(state),
    }));

    return (
        <Header {...props} imgURL={imgBaseUrlSelectors}/>
    );
};

export default HeaderContainer;